import { render } from "./MessageAbtestReviewPage.vue?vue&type=template&id=09c88262"
import script from "./MessageAbtestReviewPage.vue?vue&type=script&lang=js"
export * from "./MessageAbtestReviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__